<template>
  <div class="card-container w-full pt-22 flex flex-col items-center">
    <img class="mt-8 w-[380px]" :src="error" />
    <section class="text-slate-900 font-semibold text-lg">ページに予期しないエラーが発生しました！</section>
    <a-button class="mt-4" @click="goHome">ホームページに戻る</a-button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import error from '@/assets/images/error.svg';

const router = useRouter();

const goHome = () => {
  router.push({ path: '/' });
};
</script>

<style lang="scss"></style>
